import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { canManageTokens } from "../AIChatBot/tokenAccess";

/**
 * Blocks direct URL access to token admin pages for non-admin roles.
 * Mirrors RoleBaseAccess, but keys off group_profile_order (SPARTA Admin / Lease Admin).
 */
const TokenAdminAccess = (OriginalComponent) => {
  const NewComponent = (props) => {
    const { permission } = useSelector((state) => state.leases);

    if (canManageTokens(permission)) {
      return <OriginalComponent {...props} />;
    }

    return (
      <div style={{ width: "100vw", height: "100vh", position: "fixed" }}>
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#000000",
            textAlign: "center",
            margin: "0 auto"
          }}
        >
          <br />
          <br />
          Sorry, You do not have access to the Page.
          <br />
          Please contact to Acumen for access
          <br />
          <Link to="/ai-chat"> Go Back</Link>
        </div>
      </div>
    );
  };
  return NewComponent;
};

export default TokenAdminAccess;
